import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PerfectWeekWizard } from '../components/onboarding/PerfectWeekWizard';
import { PeriodProgressPanel } from '../components/activity/PeriodProgressPanel';
import { useActivityPlan } from '../contexts/ActivityPlanContext';
export function PerfectWeekPage() {
  const navigate = useNavigate();
  const {
    plan,
    persona
  } = useActivityPlan();
  return <main className="w-full px-4 py-5 sm:px-6 sm:py-6 lg:px-8" data-id="element-823" data-mp="3idi7y69iph7p">
      <div className="mx-auto flex w-full max-w-5xl flex-col gap-5" data-id="element-824" data-mp="3if3583n7ve99">
        <header data-id="element-825" data-mp="3dkyr90fja5yo">
          <h1 className="text-2xl font-bold tracking-tight text-navy-900" data-id="element-826" data-mp="3dkgqbqhxf3kf">
            My Perfect Week
          </h1>
          <p className="mt-1 text-sm text-navy-600" data-id="element-827" data-mp="33odqwseglj16">
            {plan.onboarded ? `Set the activities and volumes that build your business. Everything on your dashboard is derived from this plan — ${plan.lastUpdatedLabel.toLowerCase()}.` : 'Answer these five questions once. We turn your answers into daily priorities you can log in two taps.'}
          </p>
        </header>

        <PerfectWeekWizard key={persona} onComplete={() => navigate('/')} data-id="element-828" data-mp="3rm2wcg8ov85y" />

        {plan.onboarded ? <div data-id="element-829" data-mp="3cxyn02vj08zu">
            <h2 className="mb-3 text-sm font-semibold text-navy-900" data-id="element-830" data-mp="3cy8574abxbuz">
              How your current plan is tracking
            </h2>
            <PeriodProgressPanel period="quarter" data-id="element-831" data-mp="3hwt1wtqdhdeo" />
          </div> : null}
      </div>
    </main>;
}